import { getSanitizedErrorFromError } from '@canvas/error';
import { captureException } from '@canvas/sentry-react';

import { type IdentifiedError } from './types';

export function sendErrorDetailsToSentry(
  { error, type, isRecoverable }: IdentifiedError,
  captureLocation: string,
) {
  const level = isRecoverable ? 'error' : 'fatal';
  error.message = getSanitizedErrorFromError(error);
  const sentryErrorId = captureException(error, {
    level,
    tags: {
      errorType: type,
      isRecoverableError: isRecoverable,
      captureLocation,
    },
  });
  return sentryErrorId;
}
